import "./component.scss";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  back(event) {
    event.preventDefault();

    // Use browser history to restore scroll position
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback: navigate to the href if no history
      window.location.href = event.currentTarget.href;
    }
  }
}
